/* eslint-disable no-unused-vars */

import React, { memo, useState } from 'react';

import Icon from '@components/icon-component';

import CollapseableHeader from './collapseable-header';
import style from './collapseable.module.scss';

const Collapseable = ({
  children,
  title,
  subTitle,
  noAction,
  downloaded,
  onDelete,
  onEdit,
  onDownload,
  subTitleClass = '',
  subTitleErrorClass = '',
  dot = false,
  dotColor = '#e02b2b',
  openCollapse = false,
  showEllipseOnTitleSecond = false,
  error = false,
  innerBodyForNoAsset = null,
  headerWidth = null,
  titleFirstCHild = null
}) => {
  const [collapse, setCollapse] = useState(openCollapse);
  return (
    <div className={`${style.container} ${error && style.redBorder}`}>
      <CollapseableHeader
        titleFirst={title}
        titleSecond={subTitle}
        titleFirstCHild={titleFirstCHild}
        dotColor={dotColor}
        onClick={() => setCollapse((prev) => !prev)}
        subTitleClass={`${subTitleClass} ${error && subTitleErrorClass}`}
        dot={dot}
        collapse={collapse}
        showEllipseOnTitleSecond={showEllipseOnTitleSecond}
        headerWidth={headerWidth}
      />

      {collapse ? (
        <>
          {innerBodyForNoAsset && innerBodyForNoAsset()}
          <div
            className={style.collapseBody}
            style={{
              transition: 'all 1.5s ease-in'
            }}
          >
            <div className={style.showPart}>
              {children}
              {!noAction && (
                <div
                  className={style.sectionLast}
                  style={{
                    marginTop: '16px'
                  }}
                >
                  <Icon name={'delete'} alt="delete" onClick={onDelete} />
                  <div className={style.sectionLast} style={{ gap: 10 }}>
                    <Icon name={'edit-circle'} alt="edit" onClick={onEdit} />
                    {downloaded && (
                      <Icon name={'inspection-black'} alt="edit" onDownLoad={onDownload} />
                    )}
                  </div>
                </div>
              )}

              {downloaded && (
                <div
                  className={style.sectionLast}
                  style={{
                    marginTop: '16px'
                  }}
                >
                  <div></div>
                  <div className={style.sectionLast} style={{ gap: 10 }}>
                    {downloaded && <Icon name={'download-edit'} alt="edit" onClick={onDownload} />}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        ''
      )}
    </div>
  );
};

export default memo(Collapseable);
